import React from 'react';
import {
  FairBanner,
  HighLightBusiness,
  HighLightPromotion,
  FairListProduct
} from './sub-view';
import {
  HomeBanner,
  HighlightPromotionContainer,
  FavoriteCategoryContainer,
  HighlightProductByCategoryContainer,
  TradeNewsContainer,
  EasyNeedOfferContainer,
  NeedOffersByCategoryContainer,
  SupportInfoContainer,
  NewsLetterRegister
} from 'components/home/sub-view';

import style from './style.scss';

class FairDashBoard extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className='fair-dashboard-container'>
        <FairBanner imgSrc={require('assets/images/fair/banner.png')}/>
        <div className="center">
          <FavoriteCategoryContainer redTitle='Hội chợ'/>
          <HighLightBusiness/>
          <HighlightPromotionContainer/>
          <div className='wrap-container-product mt30'>
            <FairListProduct title='Sản phẩm chưng bày'/>
            <FairListProduct title='Sản phẩm đang bán'/>
          </div>
          <HighLightPromotion/>
          <TradeNewsContainer/>
          <SupportInfoContainer/>
        </div>
        <NewsLetterRegister/>
      </div>
    );
  }
}

export default FairDashBoard;


// WEBPACK FOOTER //
// ./components/fair/FairDashBoard.jsx